export default __webpack_public_path__ + "static/media/SPS.cdbd5138.svg";